import { DynamicDataTable } from '@/components/data-table-builder/data-table.types';
import { Component, inject, Input, OnInit } from '@angular/core';
import { getPlanningDataTableObject } from './utils/planning-data-table-object';
import { DataTableBuilderComponent } from '@/components/data-table-builder/data-table-builder.component';
import { MeetingRepository } from '@/store/meeting-state/meeting-state.repository';

@Component({
  selector: 'sm-planning-data-table',
  imports: [DataTableBuilderComponent],
  templateUrl: './planning-data-table.component.html',
  styleUrl: './planning-data-table.component.scss',
})
export class PlanningDataTableComponent implements OnInit {
  meetingRepository = inject(MeetingRepository);
  @Input() isDisabled!: boolean;
  @Input() data!: any[];
  dataTableObject: DynamicDataTable = getPlanningDataTableObject({ store: this.meetingRepository, isDisabled: this.isDisabled });

  ngOnInit(): void {
    this.dataTableObject = getPlanningDataTableObject({ store: this.meetingRepository, isDisabled: this.isDisabled });
  }

  loading = false;
}
